<template>
  <div id="app">
    <router-view />
    <b-modal
      :visible="clientVersion.unsupported || clientVersion.updateAvailable"
      :title="
        clientVersion.unsupported
          ? 'New version required'
          : 'Latest version available'
      "
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      ok-only
      ok-title="REFRESH"
      @ok="refresh"
    >
      <p v-if="clientVersion.unsupported">
        A new version of TradiePass is required. Finish what you are doing, then
        refresh to continue.
      </p>
      <p v-else>
        A new version of TradiePass is available. Refresh to update to the
        latest version.
      </p>
    </b-modal>
  </div>
</template>

<script>
import clientVersion from '@/utils/clientVersion'
import { applyUpdate } from '@/registerServiceWorker'

export default {
  data() {
    return { clientVersion }
  },
  methods: {
    refresh(event) {
      event.preventDefault()
      applyUpdate()
    },
  },
}
</script>

<style lang="scss">
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
